import { render, staticRenderFns } from "./LaundryForm.vue?vue&type=template&id=8ece6a88&scoped=true&"
import script from "./LaundryForm.vue?vue&type=script&lang=js&"
export * from "./LaundryForm.vue?vue&type=script&lang=js&"
import style0 from "./LaundryForm.vue?vue&type=style&index=0&id=8ece6a88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ece6a88",
  null
  
)

export default component.exports